/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#shared/api/client'
import type { VerifyRegistrationOptions, VerifyRegistrationResponses } from '../models/VerifyRegistration'
import { client } from '#shared/api/client'

/**
 * @summary A finished registration signs the new account in: the response sets the
 * session cookie alongside the body. Under an upgrade session the guest is
 * upgraded instead, and the cookie is the full session the upgrade session
 * was rotated into, inside the upgrade's transaction.
 * {@link /api/webauthn/verify-registration}
 */
export function verifyRegistration<ThrowOnError extends boolean = true>(options: Options<VerifyRegistrationOptions, ThrowOnError>): Promise<RequestResult<VerifyRegistrationResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'POST', url: '/api/webauthn/verify-registration', ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<VerifyRegistrationResponses, ThrowOnError>>
}
